var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm._.isEmpty(_vm.order))?_c('div',{ref:"container",staticClass:"container-fluid position-relative"},[_c('OrderMailTagExportPageContent',{attrs:{"order":_vm.order}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }